import getParameter from './modules/get-parameter';
import errorMsgs from './modules/error-messages';
import serviceUrl from './modules/service-url';
import intlUrl from './modules/intl-url';
import Plurr from 'plurr';
const plurr = new Plurr();

const departmentIdMap = {
  'engineering': 'engineering',
  'product-development': 'engineering',
  'augmented-intelligence': 'engineering',
  'platform-api': 'engineering',
  'quality-assurance': 'engineering',

  'design': 'design',

  'product-management': 'product-management',

  'operations': 'operations',
  'information-technology': 'operations',

  'security': 'security',

  'marketing': 'marketing',

  'sales-partnerships': 'sales-partnerships',
  'sales': 'sales-partnerships',
  'partnerships': 'sales-partnerships',

  'analytics': 'analytics',

  'internships': 'internships',

  'new-graduates': 'new-graduates',

  'customer-support': 'customer-support',

  'branded-products': 'branded-products',

  'legal': 'legal',

  'finance': 'finance',

  'people': 'people',

  'talent': 'talent',

  'facilities': 'facilities',

  'other': 'other',
  'receptionist': 'other',
  'accounting': 'other',
  'administrative': 'other',
  'no-department': 'other',
};

const greenhouseData = Promise.resolve($.ajax({
  type: 'POST',
  url: 'https://api.greenhouse.io/v1/boards/evernote/embed/departments',
  dataType: 'jsonp',
  cache: false,
  async: true,
}));

if (window.location.href.includes('/careers/locations')) {
  populateLocationsJobsList();
} else if (window.location.href.includes('/careers')) {
  populateJobsList();
}

async function populateJobsList() {
  // de-dupe jobs with the same title in the same departmentId
  const jobDedupe = {};

  const result = await greenhouseData;
  for (let department of result.departments) {
    let queryDep = querify(department.name);
    let departmentId = departmentIdMap[queryDep] || 'other';
    for (let job of department.jobs) {
      let jobTitle = $.trim(job.title);
      let jobFullTitle = querify(jobTitle + '-' + departmentId);
      if (!jobDedupe[jobFullTitle]) {
        jobDedupe[jobFullTitle] = true;
        $('#' + departmentId).removeClass('category');  // unhide
        let url = intlUrl('/careers/job?id=' + job.id + '&gh_jid=' + job.id)
        let jobLink = $('<a>')
          .attr('href', url)
          .text(jobTitle);
        let listItem = $('<li>')
          .attr('id', 'job-' + jobFullTitle)
          .append(jobLink);
        $('#' + departmentId + ' ul')
          .append(listItem);
      } else {
        let queryJob = querify(job.title);
        let url = intlUrl(
          '/careers/locations?job=' + queryJob + '&dep=' + queryDep);
        $('#job-' + jobFullTitle + ' a')
          .attr('href', url);
      }
    }
  }
}

async function populateLocationsJobsList() {
  /*
  /careers/locations is an endpoint used to display the locations where a
  position is available, if available in multiple locations. When extracting
  data from the GreenHouse json, we filter the job openings to just those that
  match the title specified in the GET parameters. Then we display links for
  each location where the job is available.
  */
  const urlParams = getParameter();
  if (urlParams.dep === undefined || urlParams.job === undefined) {
    return locationQueryError('missing-query');
  }
  const queryDep = urlParams.dep;
  const queryJob = urlParams.job;

  const result = await greenhouseData;
  const depIndex = result.departments
    .findIndex(dep => querify(dep.name) == queryDep);
  if (depIndex == -1) {
    return locationQueryError('department-not-found');
  }
  const department = result.departments[depIndex];
  const jobs = department.jobs
    .filter(job => querify(job.title) == queryJob);
  if (!jobs.length) {
    return locationQueryError('job-not-found');
  }
  $('.job-title').text(jobs[0].title);
  for (let job of jobs) {
    let url = intlUrl('/careers/job?id=' + job.id + '&gh_jid=' + job.id);
    let jobLink = $('<a>')
      .attr('href', url)
      .text(job.location.name);
    let listItem = $('<li>').append(jobLink);
    $('#locations').append(listItem);
  }
}

// normalize a string for insertion into the query part of a URL
function querify(s) {
  return $.trim(s)
    .toLowerCase()
    .replace(/&/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-');
}

function locationQueryError(code) {
  const msgLink = $('<a>')
    .attr('href', serviceUrl('/SupportLogin.action'))
    .text(errorMsgs['_contacting_link_localizable']);
  const msgText = plurr.format(errorMsgs.network_bug_localizable, {
    _contacting_link: $('<div>').append(msgLink).html(),
    C: code,
  });
  const msgDom = $('<h2>')
    .addClass('error')
    .html(msgText);
  return $('#content')
    .empty()
    .append(msgDom);
}



// WEBPACK FOOTER //
// ./webroot/yinxiang/media/js/careers.js